/* eslint-disable */
import React, { useEffect } from 'react';
import { Security } from '@okta/okta-react';
import { ToastContainer, toast } from 'react-toastify';
import ReactGA from 'react-ga4'
import 'react-toastify/dist/ReactToastify.css';
import './App.scss';
import '../src/utils/i18n'
import { GA_ID } from '../src/utils/config'
import { applicationAuthClient, janssenApplicationAuthClient } from './okta/oktaClient';

// components
import Content from './components/content';

const oktaAuth = localStorage.getItem('tenant') === 'GlobalInnovMed' ?
  janssenApplicationAuthClient : applicationAuthClient

if (GA_ID) {
  ReactGA.initialize(GA_ID, {
    gaOptions: {
      cookieDomain: 'none'
    }
  })
}

function App(props) {
  const restoreOriginalUri = (_oktaAuth, originalUri) => {
    window.location.replace(originalUri)
  }

  const callLogin = async () => {
    if (oktaAuth.isLoginRedirect()) {
      try {
        await oktaAuth.handleRedirect()
      } catch (e) {
        // toast.error(e.message)
      }
    } else if (!(await oktaAuth.isAuthenticated())) {
      // oktaAuth.signInWithRedirect();
    } else {
    }
  }

  useEffect(() => {
    callLogin()
  }, [oktaAuth])

  return (
    <div className="App">
      <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
        <Content />
        <ToastContainer hideProgressBar autoClose={5000} />
      </Security>
    </div>
  )
}

export default App
